import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { FeatureFlagsService } from 'src/app/services/feature-flags/feature-flags.service';
import { AuthService } from 'src/app/services/http/auth.service';
import * as FeatureFlagActions from '../actions/feature-flags.actions';
import { deduplicatingSwitchMap } from 'src/app/utils/deduplicatingSwitchMap';

@Injectable()
export class FeatureFlagsEffects {
  constructor(
    private actions$: Actions,
    private featureFlagsService: FeatureFlagsService,
    private authService: AuthService
  ) {}

  loadFeatureFlags$ = createEffect(() => this.actions$.pipe(
    ofType(FeatureFlagActions.LOAD_FEATURE_FLAGS),
    deduplicatingSwitchMap((action: FeatureFlagActions.LoadFeatureFlags) => {
      return this.featureFlagsService.getFeatureFlags().pipe(
        switchMap((res: any) => {
          return of(new FeatureFlagActions.FeatureFlagsSuccess(res));
        }),
        catchError(err => {
          return of(new FeatureFlagActions.FeatureFlagsError(err.message));
        })
      );
    })
  ));
}
